import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireforkonkantourpackage() {



const cardData =
{
  keyword: 'Bus Hire for Konkan Tour Package',
  heading: 'Sanavi Travels: Bus Hire for Konkan Tour Package',
  headingDescription: 'Sanavi Travels offers reliable Bus Hire for Konkan Tour Package services for families, groups, corporate teams, and leisure travelers looking for comfortable, well-planned, and safe group travel across the scenic Konkan belt with professional drivers and flexible tour planning.',

  top: 'Top Travel Experiences with Konkan Tour Bus Hire',

  "topPlaces": [
    {
      "title": "Scenic Konkan Coastal Highway Journey",
      "description": "The Konkan region is known for its breathtaking coastal highways, lush greenery, winding ghat roads, rivers, and seaside villages. Traveling through Konkan by bus allows groups to experience the natural beauty of the Western Ghats, coconut plantations, paddy fields, and sea views together. A hired bus ensures everyone enjoys the scenery without the stress of driving, navigation, or managing multiple vehicles. The journey itself becomes a memorable part of the tour, especially during monsoon and winter seasons when Konkan is at its most beautiful."
    },
    {
      "title": "Beach Destinations of Konkan",
      "description": "Konkan is home to some of Maharashtra’s most pristine beaches such as Ganpatipule, Tarkarli, Malvan, Velneshwar, Harihareshwar, and Diveagar. Bus hire for Konkan tour packages makes it easy to cover multiple beach destinations in a single trip. Groups can carry beach gear, food supplies, and luggage comfortably while enjoying relaxed travel between beaches without worrying about parking or local transport availability."
    },
    {
      "title": "Family Konkan Holiday Tours",
      "description": "Families prefer bus hire for Konkan tours because it offers safety, comfort, and togetherness throughout the journey. Children, elders, and large family groups benefit from spacious seating, smooth rides, and flexible breaks. Traveling together in one bus allows families to share experiences, enjoy conversations, and relax while reaching hotels, resorts, and homestays directly."
    },
    {
      "title": "Group & Friends Konkan Trips",
      "description": "Konkan is a popular destination for friends’ trips, reunion tours, and celebration travel. Hiring a bus ensures the entire group stays together, avoids coordination issues, and enjoys the road trip as part of the vacation. Music, group bonding, scenic stops, and planned sightseeing make bus travel ideal for friends exploring Konkan together."
    },
    {
      "title": "Corporate Konkan Offsite Tours",
      "description": "Many companies organize corporate offsites, retreats, and team-building programs in Konkan resorts and beach properties. Bus hire offers professional, punctual, and organized transportation for employees. It ensures on-time arrivals, disciplined travel schedules, and comfortable journeys that reflect a professional corporate travel approach."
    },
    {
      "title": "Religious & Cultural Konkan Tours",
      "description": "Konkan is rich in temples, forts, and cultural heritage including Ganpatipule Temple, Harihareshwar Temple, and historic coastal forts. Bus tours allow pilgrims and cultural groups to travel peacefully, follow planned itineraries, and visit multiple spiritual sites without travel stress or logistical challenges."
    },
    {
      "title": "Monsoon Konkan Tourism",
      "description": "Monsoon is one of the best times to visit Konkan due to lush greenery, waterfalls, and misty ghats. Professional bus drivers experienced in Konkan terrain ensure safe travel during rains. Well-maintained buses with strong braking systems and reliable performance are crucial for monsoon tours, making bus hire the safest option."
    },
    {
      "title": "Outstation Long-Distance Comfort",
      "description": "Konkan tours often involve long-distance travel from Pune, Mumbai, or nearby cities. Buses provide better comfort for extended journeys with ample legroom, luggage space, and rest stops. Passengers can relax, sleep, or enjoy the views while the driver manages long highway stretches."
    },
    {
      "title": "Flexible Itineraries & Multiple Destinations",
      "description": "Bus hire allows tour planners to customize Konkan itineraries with multiple destinations, sightseeing halts, and food breaks. Unlike fixed transport options, buses provide flexibility to adjust routes, stay durations, and visit offbeat locations, making the tour more personalized and enjoyable."
    },
    {
      "title": "Safe Group Coordination",
      "description": "Traveling in a single bus eliminates convoy risks, communication gaps, and delays associated with multiple vehicles. It ensures everyone reaches destinations together, maintains tour discipline, and improves overall safety and travel coordination throughout the Konkan tour."
    }
  ],

  "services": [
    {
      "name": "Bus Hire for Konkan Tour Package",
      "description": "Sanavi Travels offers end-to-end bus hire services for Konkan tour packages, covering coastal destinations, hill routes, temples, beaches, and resorts. Our buses are spacious, clean, and well-maintained, making them ideal for long-distance Konkan travel. Professional drivers handle ghats, highways, and village roads confidently, ensuring passenger safety and comfort throughout the tour. Flexible rental plans, planned halts, and transparent pricing make Konkan bus tours smooth and worry-free."
    },
    {
      "name": "AC Bus for Konkan Tour",
      "description": "AC buses are perfect for Konkan tours during summer and humid weather conditions. Air-conditioned interiors ensure a comfortable environment during long coastal journeys. These buses are preferred by families, senior citizens, and corporate groups seeking enhanced comfort without travel fatigue."
    },
    {
      "name": "Non AC Bus Hire Konkan",
      "description": "Non AC buses provide a cost-effective travel option for Konkan tours during pleasant weather. They offer spacious seating, safety, and reliability while keeping overall tour costs manageable, making them ideal for budget groups, students, and large family tours."
    },
    {
      "name": "Luxury Bus Hire Konkan",
      "description": "Luxury buses for Konkan tours feature premium seating, smooth suspension, and enhanced interiors. These buses are suitable for corporate offsites, destination weddings, and premium tourist groups looking for a high-end travel experience across coastal routes."
    },
    {
      "name": "Mini Bus on Rent for Konkan Tour",
      "description": "Mini buses are ideal for small groups and families exploring Konkan destinations. They provide flexibility, easy maneuvering on narrow coastal roads, and comfortable seating while maintaining cost efficiency."
    },
    {
      "name": "32 Seater Bus Konkan Tour",
      "description": "32 seater buses are widely used for medium-sized Konkan tour groups. They balance seating capacity, comfort, and luggage space, making them suitable for multi-day coastal itineraries."
    },
    {
      "name": "35 Seater Bus Hire Konkan Tour",
      "description": "35 seater buses are perfect for large tour groups, school excursions, and corporate teams traveling across Konkan. These buses ensure everyone travels together comfortably with sufficient luggage capacity."
    },
    {
      "name": "Bus for Family Konkan Tour",
      "description": "Family-focused bus services ensure smooth travel for all age groups. Comfortable seating, flexible breaks, and safe driving make long Konkan journeys enjoyable for children and elderly passengers."
    },
    {
      "name": "Bus for Corporate Konkan Tour",
      "description": "Corporate bus hire supports structured travel for company offsites, training programs, and retreats in Konkan. Professional service, punctual schedules, and comfortable travel conditions enhance corporate tour efficiency."
    },
    {
      "name": "Affordable Bus Rental Konkan Tour",
      "description": "Affordable Konkan bus rental packages help groups manage travel budgets without compromising safety or comfort. Transparent pricing and flexible plans ensure excellent value for money."
    },
    {
      "name": "Best Bus Service Konkan Tour",
      "description": "Sanavi Travels is known for dependable Konkan tour bus services, offering consistent quality, experienced drivers, and customer-focused travel solutions."
    },
    {
      "name": "Bus with Driver Konkan Tour",
      "description": "All Konkan tour bus rentals include experienced drivers familiar with coastal highways, ghats, and rural routes, allowing passengers to relax and enjoy the journey."
    },
    {
      "name": "Bus for Wedding Konkan Tour",
      "description": "Destination wedding travel in Konkan becomes easy with bus hire services that manage guest transportation efficiently and reliably."
    },
    {
      "name": "Bus for Picnic Konkan Tour",
      "description": "Bus hire is ideal for Konkan picnic trips, allowing groups to travel together, carry food and luggage comfortably, and enjoy the journey stress-free."
    },
    {
      "name": "Outstation Bus for Konkan Tour",
      "description": "Outstation Konkan bus services support long-distance travel from Pune, Mumbai, and nearby cities with planned breaks, safe driving, and reliable vehicles."
    }
  ],

  "tableData": [
    ["Konkan Tour Bus Hire", "AC Bus"],
    ["Non AC Bus", "Luxury Bus"],
    ["32 Seater Bus", "35 Seater Bus"],
    ["Family Tours", "Corporate Tours"],
    ["Beach Trips", "Outstation Travel"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Experienced Konkan Drivers", "WhyChoosedescription": "Drivers skilled in coastal roads and ghat sections." },
    { "WhyChooseheading": "Comfort for Long Journeys", "WhyChoosedescription": "Spacious seating for extended travel hours." },
    { "WhyChooseheading": "Multiple Bus Options", "WhyChoosedescription": "Mini, standard, and luxury buses available." },
    { "WhyChooseheading": "Safe & Maintained Fleet", "WhyChoosedescription": "Regular servicing and safety checks." },
    { "WhyChooseheading": "Flexible Tour Planning", "WhyChoosedescription": "Custom itineraries and stopovers." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "Clear costs with no hidden charges." },
    { "WhyChooseheading": "Group Coordination", "WhyChoosedescription": "Entire group travels together smoothly." },
    { "WhyChooseheading": "Trusted Travel Partner", "WhyChoosedescription": "Sanavi Travels is known for reliable service." }
  ]
};

const faqData = [
  { question: 'Do you provide bus hire for Konkan tour packages?', answer: 'Yes, Sanavi Travels offers complete bus hire services for Konkan tours.' },
  { question: 'What bus types are available for Konkan tours?', answer: 'AC, Non AC, luxury, mini buses, 32 seater, and 35 seater buses are available.' },
  { question: 'Is Konkan bus travel safe during monsoon?', answer: 'Yes, with experienced drivers and well-maintained buses, monsoon travel is safe.' },
  { question: 'Can we customize the Konkan tour itinerary?', answer: 'Yes, routes and stopovers can be customized.' },
  { question: 'Is this service suitable for families?', answer: 'Absolutely, family-friendly buses are available.' },
  { question: 'Do you offer corporate Konkan tours?', answer: 'Yes, corporate and team outing travel is supported.' },
  { question: 'Is luggage space sufficient?', answer: 'Yes, buses provide ample luggage space.' },
  { question: 'Are drivers experienced in Konkan routes?', answer: 'Yes, drivers are trained for Konkan terrain.' },
  { question: 'How do I book a Konkan tour bus?', answer: 'You can book via our website or customer support.' },
  { question: 'Do you offer affordable packages?', answer: 'Yes, budget-friendly Konkan tour packages are available.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Joshi',
    feedback: 'Our Konkan tour with Sanavi Travels was extremely comfortable and well-organized.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Clean bus, experienced driver, and smooth Konkan journey. Highly recommended!',
    rating: 5
  }
];






















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for Konkan Tour Package - Sanavi Travels",
  "description": "Sanavi Travels offers bus hire for Konkan tour packages, including family trips, corporate travel, weddings, picnics, and outstation journeys. AC and Non-AC buses, luxury buses, 32-seater and 35-seater options, and mini buses are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Call : +91 7387507373 | Bus Hire for Konkan Tour Package | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book buses for Konkan tour packages with Sanavi Travels. AC & Non-AC luxury buses, 32-seater, 35-seater, and mini buses for family trips, corporate travel, weddings, picnics, and outstation journeys with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/287.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireforkonkantourpackage;